<template>
  <div>
    <div id="golbal_service" draggable="true" :style="{ right, bottom }">
      <div draggable="false" class="golbal_service_box">
        <div class="golbal_service_icon faq" @click="lookFAQ">
          <img
            src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/eline/faqf.png"
            onMouseOut="this.src='https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/eline/faqf.png'"
            onMouseOver="this.src='https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/eline/faq.png'"
            width="24"
            height="24"
          />
          <div class="golbal_service_more hover_blue" style="padding: 8px 12px">
            <span class="wsn fs12">常见问题解答</span>
            <div class="arrow"></div>
          </div>
        </div>
        <div class="golbal_service_icon icon_service" @click="handleClick">
          <div class="golbal_service_more hover_blue" style="padding: 8px 12px">
            <span class="wsn fs12">客服QQ</span>
            <div class="arrow"></div>
          </div>
        </div>
        <div class="golbal_service_icon icon_line">
          <div class="golbal_service_more tac" style="padding: 8px 12px">
            <span class="wsn fs12">客服热线</span>
            <div class="wsn c117 fs14">0571-86395960</div>
            <div class="arrow"></div>
          </div>
        </div>
        <div class="golbal_service_icon icon_robot" @click="handleClick">
          <div class="golbal_service_more hover_blue" style="padding: 8px 12px">
            <span class="wsn fs12">定制机器人</span>
            <div class="arrow"></div>
          </div>
        </div>
        <div class="golbal_service_icon icon_qrcode">
          <div class="golbal_service_more tac" style="padding: 12px 16px">
            <span class="wsn fs12">扫描二维码关注公众号</span>
            <div class="c117 fs14" style="padding-top: 4px">
              <img class="dib" width="120px" height="120px" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/qr_code.png" />
            </div>
            <div class="arrow"></div>
          </div>
        </div>
      </div>
    </div>

    <FaqPopup v-if="dialogVisible" :popType="dialogVisible" @close="closeDialog" />
  </div>
</template>

<script>
import { oss_url_common } from '@/utils'
import { openQQ } from '@/utils/functions'
import FaqPopup from './FaqPopup'

export default {
  name: 'ContactQQ',
  components: { FaqPopup },
  data() {
    return {
      imgSrc: require('./faq.png'),
      oss_url_common,
      isMove: false,
      right: '10px',
      bottom: '131px',
      dialogVisible: false
    }
  },
  mounted() {
    this.getPostion()

    const dom = document.getElementById('golbal_service')
    const { width, height } = dom.getBoundingClientRect()
    const { innerWidth, innerHeight } = window

    let offsetX = 0
    let offsetY = 0
    dom.ondragstart = e => {
      offsetX = e.offsetX
      offsetY = e.offsetY
    }
    dom.ondragover = e => {
      e.preventDefault()
    }
    dom.ondrag = e => {
      if (e.clientX === 0 && e.clientY === 0) return
      let r = ~~(innerWidth - (e.clientX - offsetX + width))
      let b = ~~(innerHeight - (e.clientY - offsetY + height))
      // 边界处理
      r < 0 && (r = 0)
      r > innerWidth - width && (r = innerWidth - width)
      b < 0 && (b = 0)
      b > innerHeight - height && (b = innerHeight - height)

      let right = r + 'px'
      let bottom = b + 'px'
      dom.style.right = right
      dom.style.bottom = bottom

      localStorage.setItem('ContactQQPostion', `${right},${bottom}`)
    }
  },
  methods: {
    getPathName() {
      if (location.pathname == '/em/') return true
      if (location.pathname == '/aci/') return true
      if (location.pathname == '/ams/') return true
      if (location.pathname == '/afr/') return true
      if (location.pathname == '/cps/') return true
      if (location.pathname == '/cpsqd/') return true
      if (location.pathname == '/vgm/') return true
      if (location.pathname == '/ics/') return true
      // if(location.pathname == '/isf/') return true
      // if(location.pathname == '/') return true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    lookFAQ() {
      this.dialogVisible = true
    },
    handleClick() {
      if (!this.isMove) {
        openQQ()
      }
    },
    getPostion() {
      let position = localStorage.getItem('ContactQQPostion')
      if (!position) return
      let arr = position.split(',')
      if (arr.length !== 2) return
      this.right = arr[0]
      this.bottom = arr[1]
    }
  }
}

const debounce = (func, wait = 50) => {
  let timer = 0
  return function (...args) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, wait)
  }
}
</script>

<style lang="less" scoped>
@oss_url_common: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home';
.wsn {
  white-space: nowrap;
}
.tac {
  text-align: center;
}
.fs10 {
  font-size: 10px;
}
.fs12 {
  font-size: 12px;
}
.fs14 {
  font-size: 14px;
}
.c9 {
  color: #999;
}
.c117 {
  color: #1170eb;
}
.dib {
  display: inline-block;
}
#golbal_service {
  width: 52px;
  border-radius: 26px;
  position: fixed;
  z-index: 100;
  background-color: #ffffff;
  padding: 18px 14px 2px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;

  .golbal_service_box {
    width: 24px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .golbal_service_icon {
      width: 24px;
      height: 24px;
      background-size: 24px;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      margin-bottom: 16px;
      position: relative;

      &::after {
        content: '';
        width: 15px;
        height: 1px;
        background-color: #dedede;
        position: absolute;
        left: 4px;
        bottom: -8px;
        filter: blur(0.5px);
      }

      &:hover {
        .golbal_service_more {
          opacity: 1;
          visibility: visible;
          transform: translateX(calc(-100% - 25px));
        }
      }
    }

    .golbal_service_icon:last-child {
      &::after {
        display: none;
      }
    }

    @icons: service, line, robot, qrcode;
    each(@icons,{

      .icon_@{value}{
        background-image: url("@{oss_url_common}/golbal_@{value}.png");
        &:hover{
          background-image:  url("@{oss_url_common}/golbal_@{value}_h.png");
        }
      }
    });

    .golbal_service_more {
      opacity: 0;
      visibility: hidden;
      box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.1);
      padding: 8px;
      background-color: #ffffff;
      border-radius: 4px;
      position: absolute;
      transition: 0.3s;
      text-align: right;
      transform: translateX(calc(-100% - 20px));

      .arrow {
        position: relative;

        &::before {
          content: '';
          position: absolute;
          width: 40px;
          height: 57px;
        }

        &::after {
          content: '';
          width: 0;
          height: 0;
          border: 7px solid transparent;
          border-left-color: #ffffff;
          position: absolute;
          right: -21px;
        }
      }
      &.hover_blue:hover {
        color: #1170eb;
      }
    }
    .faq .golbal_service_more {
      top: -9px;
    }
    .faq .golbal_service_more .arrow::after {
      top: -19px;
    }
    .faq .golbal_service_more .arrow::before {
      top: -32px;
      right: -40px;
      height: 40px;
    }
    .icon_service .golbal_service_more {
      top: -9px;
    }
    .icon_line .golbal_service_more {
      top: -17px;
    }
    .icon_robot .golbal_service_more {
      top: -9px;
    }
    .icon_qrcode .golbal_service_more {
      top: -22px;
    }
    .icon_service .golbal_service_more .arrow::after {
      top: -19px;
    }
    .icon_line .golbal_service_more .arrow::after {
      top: -30px;
    }
    .icon_robot .golbal_service_more .arrow::after {
      top: -19px;
    }
    .icon_qrcode .golbal_service_more .arrow::after {
      top: -118px;
      right: -29px;
    }
    .icon_service .golbal_service_more .arrow::before {
      top: -32px;
      right: -40px;
      height: 40px;
    }
    .icon_line .golbal_service_more .arrow::before {
      top: -45px;
      right: -40px;
      height: 40px;
    }
    .icon_robot .golbal_service_more .arrow::before {
      top: -32px;
      right: -40px;
      height: 40px;
    }
    .icon_qrcode .golbal_service_more .arrow::before {
      top: -141px;
      right: -40px;
    }
  }
}
</style>
